import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImgAssetDirective } from './img-asset.directive';

@NgModule({
  declarations: [ImgAssetDirective],
  exports: [ImgAssetDirective],
  imports: [CommonModule],
})
export class ImgAssetModule {}
